module.exports = __webpack_public_path__ + "img/16.79b8ff30.svg";